// Author thq
// Date 2021-04-14 13:43:11

class EmSppSource {
constructor({
        id = null,
        name = '',
        code = '',
        remark = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.code = code;
    this.remark = remark;
}
}

function newEntity() {
return new EmSppSource();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.spareparts.emSppSource.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.spareparts.emSppSource.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.em.spareparts.emSppSource.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.spareparts.emSppSource.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    nameFilter : "",
    codeFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.spareparts.emSppSource.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'codeFilter',
        label: 'label.em.spareparts.emSppSource.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.em.spareparts.emSppSource.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'code',
        label: 'label.em.spareparts.emSppSource.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.em.spareparts.emSppSource.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmSppSource, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
